var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-wrap"},[_c('g-video',{ref:"gVideo",attrs:{"contentpath":_vm.path,"coverImg":_vm.cover},on:{"listenerEvent":_vm.eventHandler}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }